@if(showText){
    <button mat-raised-button
        (click)="downloadInvoice()"
        >
        <app-icon-core color="accent" [icon]="'download'" [inline]="true" ></app-icon-core>
        <span>Download Invoice</span>
    </button>
}
@else{
    
    <button mat-icon-button
        (click)="downloadInvoice()"
        >
        <app-icon-core [icon]="'download'" [inline]="true" ></app-icon-core>
    </button>
}